import { render, staticRenderFns } from "./PortfolioSix.vue?vue&type=template&id=fb6be3fe&"
import script from "./PortfolioSix.vue?vue&type=script&lang=js&"
export * from "./PortfolioSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports